import { render, staticRenderFns } from "./WorkingAreaAlertFlags.vue?vue&type=template&id=f4638e94&scoped=true"
import script from "./WorkingAreaAlertFlags.vue?vue&type=script&lang=js"
export * from "./WorkingAreaAlertFlags.vue?vue&type=script&lang=js"
import style0 from "./WorkingAreaAlertFlags.vue?vue&type=style&index=0&id=f4638e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4638e94",
  null
  
)

export default component.exports